import { render, staticRenderFns } from "./CycleTabs.vue?vue&type=template&id=2c97c3ef"
import script from "./CycleTabs.vue?vue&type=script&lang=js"
export * from "./CycleTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports